/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaMintedResponse } from '../../models/get-gacha-minted-response';

export interface GachaServiceGetGachaMinted2$Params {
  gachaIds: Array<string>;
}

export function gachaServiceGetGachaMinted2(http: HttpClient, rootUrl: string, params: GachaServiceGetGachaMinted2$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaMintedResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGachaMinted2.PATH, 'get');
  if (params) {
    rb.path('gachaIds', params.gachaIds, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaMintedResponse>;
    })
  );
}

gachaServiceGetGachaMinted2.PATH = '/api/v3/gateway/gacha/minted/{gachaIds}';
